<template>
  <div>
    <h3 class="text-primary"> A&uacute;n no hay un repositorio creado </h3>
    <h5 v-if="!isSuperAdmin" class="text-primary"> Debe contactarse con su administrador </h5>
    <vs-button
      v-if="isSuperAdmin"
      class="mt-3"
      @click="openModal"
      icon-after color="primary"
      icon="add"
    >
      Crear repositorio
    </vs-button>
    <b-modal title="Crear repositorio" ref="newRepository" hide-footer centered>
      <h5>Esto crear&aacute; el repositorio principal de la empresa.</h5>
      <div class="row">
        <div class="col-12 text-center">
          <vs-button
            class="mt-5 ml-3"
            @click="createRepository"
            color="primary"
            :disabled="loading"
          >
            Crear
            <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
          </vs-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NewRepository',
  computed: {
    ...mapGetters('DocManagement', [
      'loading'
    ]),
    ...mapGetters('Usuario', [
      'hasPermission'
    ]),
    isSuperAdmin() {
      return this.hasPermission('FEB99');
    }
  },
  methods: {
    ...mapActions('DocManagement', [
      'createMainRepository',
      'loadRepositories'
    ]),
    openModal() {
      this.$refs.newRepository.show();
    },
    async createRepository() {
      await this.createMainRepository();
      this.$refs.newRepository.hide();
      await this.loadRepositories();
    }
  }
};
</script>
